module.exports = __webpack_public_path__ + "static/BankofAmericalogo-e89a830b44a57c58bc991a6053761dcb.png";